/* Electrodose: single review destination — /pages/review.
   Background: the Judge.me widget is rendered from product.metafields.judgeme.widget,
   whose HTML ships the "Write a review" button inline-hidden, and Judge.me code-splits
   its JS into competing flows (inline form in widget/form.js — loaded only under special
   conditions — plus a v3 write-review modal). Letting the inline form expand inside
   arbitrary pages broke layouts (homepage), so:
   - EVERYWHERE except /pages/review: the button just navigates to /pages/review
     (?review=1 / #write-review deep links redirect there too — keeps old SMS links working).
   - ON /pages/review (#edose-review-page marker): the form auto-opens; the button toggles
     it open/closed via jdgm.openForm/closeForm so its label always matches; widget/form.js
     + form.css are self-loaded through Judge.me's loader — ONLY once jdgm.$ (jQuery)
     exists, because form.js starts with a jQuery plugin and crashes without it, and with
     the force flag because the loader dedupes requested URLs; the form is un-clipped after
     opening (interrupted slideDown can freeze its height).
   - The write-review modal is CSS-suppressed globally — exactly one flow exists.
   We own all button clicks in capture phase so Judge.me's own handlers never fire.
   theme.liquid ships a hidden .jdgm-preview-badge marker so Judge.me's loader fetches its
   base scripts. Scrolling: this theme scrolls .page-wrapper, not the window (bare #anchors
   and window.scrollTo don't work) — use scrollIntoView; the theme resets scroll while
   loading, so a watchdog re-asserts position until it sticks or the user takes over. */
(function () {
  var REVIEW_PAGE = '/pages/review';
  var tries = 0;
  var formJsRequested = false;

  function onReviewPage() { return !!document.getElementById('edose-review-page'); }
  function widgetOf(el) { return el.closest('.jdgm-widget'); }
  function wrapperOf(btn) { var w = widgetOf(btn); return w && w.querySelector('.jdgm-form-wrapper'); }
  function isOpen(w) { return w && getComputedStyle(w).display !== 'none'; }

  function unclip(btn) {
    var w = wrapperOf(btn);
    if (!isOpen(w)) return;
    w.style.height = '';
    w.style.overflow = '';
    var f = w.querySelector('.jdgm-form');
    if (f) { f.style.height = ''; f.style.overflow = ''; }
  }

  function requestFormJs() {
    var j = window.jdgm;
    // form.js needs jdgm.$ (jQuery) and jdgmSettings at execute time — wait for base.
    if (formJsRequested || !j || !j.$ || !window.jdgmSettings || !j.loadScript) return;
    formJsRequested = true;
    try {
      j.loadScript(j.CDN_HOST + 'widget/form.js', null, true); // force: an earlier/aborted request may be deduped
      if (j.loadCSS && j.widgetPath) j.loadCSS(j.widgetPath('form.css'));
    } catch (e) { formJsRequested = false; }
  }

  function openInline(btn) {
    var t0 = Date.now();
    (function poll() {
      var j = window.jdgm;
      if (j && j.$ && j.openForm) {
        try { j.openForm(j.$(widgetOf(btn))); } catch (e) {}
        setTimeout(function () { unclip(btn); }, 600);
        setTimeout(function () { unclip(btn); }, 1600);
        return;
      }
      requestFormJs();
      if (Date.now() - t0 < 20000) setTimeout(poll, 300);
    })();
  }

  function closeInline(btn) {
    var j = window.jdgm;
    if (j && j.$ && j.closeForm) { try { j.closeForm(j.$(widgetOf(btn))); } catch (e) {} }
  }

  // Only one review flow: never let Judge.me's write-review modal appear.
  var guard = document.createElement('style');
  guard.textContent = '.jdgm-write-review-modal{display:none !important;}';
  document.head.appendChild(guard);

  // Own every write-review click — capture phase beats Judge.me's delegated handlers.
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.jdgm-write-rev-link');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    if (!onReviewPage()) {
      window.location.href = REVIEW_PAGE;
      return;
    }
    if (btn.getAttribute('aria-expanded') === 'true') closeInline(btn);
    else openInline(btn);
  }, true);

  function scrollTarget(btn) {
    var w = wrapperOf(btn);
    var target = (w && w.offsetHeight > 0) ? w : btn;
    target.style.scrollMarginTop = '120px';
    return target;
  }

  function watchScroll(btn) {
    var t0 = Date.now();
    var seen = false;
    var userTookOver = false;
    var stopOnInput = function () { userTookOver = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, stopOnInput, { passive: true, once: true });
    });
    (function tick() {
      if (userTookOver) return;
      var target = scrollTarget(btn);
      var r = target.getBoundingClientRect();
      var inView = r.height > 0 && r.top > -50 && r.top < window.innerHeight * 0.7;
      if (inView) {
        seen = true;
      } else if (seen) {
        return; // was in view and moved away (user scrolled) — stop fighting them
      } else {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      var elapsed = Date.now() - t0;
      var settled = document.readyState === 'complete' && seen && elapsed > 3000;
      if (!settled && elapsed < 30000) setTimeout(tick, 300);
    })();
  }

  function setup() {
    var btns = document.querySelectorAll('.jdgm-widget .jdgm-write-rev-link');
    if (!btns.length) {
      if (tries++ < 150) setTimeout(setup, 200);
      return;
    }
    btns.forEach(function (btn) {
      if (btn.style.display === 'none') btn.style.display = 'block';
    });

    if (onReviewPage()) {
      openInline(btns[0]);
      watchScroll(btns[0]);
      return;
    }
    // Old deep links (?review=1 on PDPs, #write-review) now route to the review page.
    var params = new URLSearchParams(window.location.search);
    if (params.get('review') === '1' || window.location.hash === '#write-review') {
      window.location.replace(REVIEW_PAGE);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
